(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero(hero) {
      if (hero.dataset.kintraInit === 'true') return;
      hero.dataset.kintraInit = 'true';

      var slides = hero.querySelectorAll('.kintra-hero__slide');
      if (slides.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var interval = parseInt(hero.dataset.slideInterval, 10);
      if (!interval || interval < 2000) interval = 6000;
      var TRANSITION_MS = 500; /* keep in sync with the CSS transform transition */

      var current = 0;

      /* Deferred slides carry data-src/data-srcset (see the Liquid above).
         Hydrate the next slide ahead of its turn so the swipe never shows a
         blank panel; the first hydration runs once the page has loaded. */
      function hydrate(slide) {
        if (!slide) return;
        var img = slide.querySelector('img[data-kintra-deferred]');
        if (!img) return;
        if (img.dataset.srcset) { img.setAttribute('srcset', img.dataset.srcset); delete img.dataset.srcset; }
        if (img.dataset.src) { img.setAttribute('src', img.dataset.src); delete img.dataset.src; }
        img.removeAttribute('data-kintra-deferred');
      }
      var warm = function () { hydrate(slides[1 % slides.length]); };
      if (document.readyState === 'complete') { setTimeout(warm, 500); }
      else { window.addEventListener('load', function () { setTimeout(warm, 500); }, { once: true }); }

      setInterval(function () {
        var prev = current;
        current = (current + 1) % slides.length;
        hydrate(slides[current]);
        hydrate(slides[(current + 1) % slides.length]);
        slides[prev].classList.remove('is-active');
        slides[prev].classList.add('is-leaving');    /* outgoing slides off left */
        slides[current].classList.add('is-active');  /* incoming swipes in from right */
        (function (leaving) {
          setTimeout(function () {
            /* snap the finished slide back to its waiting spot (off right) with
               no animation, ready for its next turn */
            leaving.classList.add('is-instant');
            leaving.classList.remove('is-leaving');
            void leaving.offsetWidth; /* force reflow so the snap isn't animated */
            leaving.classList.remove('is-instant');
          }, TRANSITION_MS + 60);
        })(slides[prev]);
      }, interval);
    }

    function initAll() {
      document.querySelectorAll('[data-kintra-hero]').forEach(initHero);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);

    // Smooth-scroll for the hero's in-page anchor buttons (e.g. "View
    // Different Tours" -> #tours). Honours reduced-motion; scroll-margin-top
    // on the target keeps the heading clear of the fixed header.
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-kintra-hero] a[href^="#"]');
      if (!link) return;
      var id = link.getAttribute('href').slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      if (window.history && history.replaceState) {
        history.replaceState(null, '', '#' + id);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-kintra"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('.why .feature').forEach(function (card) {
        if (card.dataset.flipInit) return;
        card.dataset.flipInit = '1';
        function toggle() {
          var flipped = card.classList.toggle('is-flipped');
          card.setAttribute('aria-expanded', flipped ? 'true' : 'false');
        }
        card.addEventListener('click', toggle);
        card.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); toggle(); }
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wildlife"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('.wild .wildcard').forEach(function (card) {
        if (card.dataset.flipInit) return;
        card.dataset.flipInit = '1';
        function toggle() {
          var flipped = card.classList.toggle('is-flipped');
          card.setAttribute('aria-expanded', flipped ? 'true' : 'false');
        }
        card.addEventListener('click', toggle);
        card.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); toggle(); }
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
